import { Form, Modal, ModalProps, Select } from 'antd';
import { useEffect, useState } from 'react';
import jobsService from '../../services/jobs.service';
import { notifyError, notifySuccess } from '../../utils/notification';

export const JobAccessListModalForm: React.FC<ModalProps & { selectedUser: any }> = ({
	visible,
	onCancel,
	selectedUser
}) => {
	const [form] = Form.useForm();
	const [companyJobs, setCompanyJobs] = useState<any>([]);

	const mountLogic = async () => {
		const [jobsResp, accessedJobsResp] = await Promise.all([
			jobsService.getJobs(),
			jobsService.getUserAccessJobs(selectedUser.id)
		]);
		setCompanyJobs(jobsResp.data);
		form.setFieldsValue({ jobIds: accessedJobsResp.data });
	};
	useEffect(() => {
		mountLogic();
	}, [selectedUser]);

	const onFinish = async values => {
		try {
			const resp = await jobsService.setUserAccessJobs(selectedUser.id, values);
			if (resp.success) {
				notifySuccess('Updated Successfully!');
				onCancel && onCancel(resp);
				return;
			}
			notifyError('Something Went Wrong!');
			onCancel && onCancel(resp);
		} catch (e: any) {
			notifyError(e.message);
		}
	};

	return (
		<Modal
			title={`Access control for ${selectedUser.profile.firstName}  ${selectedUser.profile.lastName}`}
			visible={visible}
			onCancel={onCancel}
			okText="Confirm"
			onOk={form.submit}
		>
			<Form layout="vertical" form={form} onFinish={onFinish}>
				<Form.Item name="jobIds">
					<Select
						showSearch
						filterOption={(input, option) => {
							return option?.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
						}}
						mode="multiple"
						placeholder="select jobs"
						size="middle"
					>
						{companyJobs.map(job => (
							<Select.Option value={job.id} key={job.id}>
								{job.title}
							</Select.Option>
						))}
					</Select>
				</Form.Item>
			</Form>
		</Modal>
	);
};
